const ESCAPES: Record<string, string> = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
};

export const escapeHtml = (text: string) =>
    text.replace(/[&<>"']/g, (ch) => ESCAPES[ch]);
